import HotjarPixel from './HotjarPixel';

export default HotjarPixel;
